import React from "react";
import cx from "classnames";

function ValueDisplay(props) {
  let { value, baseClassName, className, onClick, maxChars, ...otherProps } = props;
  let triggerClass = onClick ? baseClassName + "--trigger" : "";

  let formattedValue = value;
  if (formattedValue && formattedValue.length > maxChars) {
    formattedValue = formattedValue.substring(0, maxChars);
  }

  return (
    <div className={cx(baseClassName, className, triggerClass)} onClick={onClick} {...otherProps}>
      {formattedValue}
    </div>
  );
}

ValueDisplay.defaultProps = {
  baseClassName: "si-c-valuedisplay",
  maxChars: 100,
};

export default ValueDisplay;
